<template>
  <main class="dashboard user-interventions">
    <div class="container-fluid container-fluid--max">
      <TrainingSection title="Formations disponibles" :trainings="availableTrainings" id="availableTrainings" />
      <TrainingSection title="Mes formations" :trainings="myTrainings" id="myTrainings" :mine="true" class="mt-4" />
    </div>
  </main>
</template>

<script>
import TrainingSection from './TrainingSection'
import { mapState } from 'vuex'
import { scrollAnchor } from '@/utils/helpers'

export default {
  name: 'Trainings',
  components: {
    TrainingSection
  },
  data () {
    return {
      availableTrainings: [],
      myTrainings: []
    }
  },
  computed: {
    ...mapState(['trainings'])
  },
  mounted () {
    scrollAnchor(this.$router)
    this.availableTrainings = this.trainings.available
    this.myTrainings = this.trainings.mine
  },
  watch: {
    trainings (value) {
      this.availableTrainings = value.available
      this.myTrainings = value.mine
    }
  }
}
</script>
